import { render, staticRenderFns } from "./InputWithCopy.vue?vue&type=template&id=28bc1385&"
import script from "./InputWithCopy.vue?vue&type=script&lang=js&"
export * from "./InputWithCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports